import { createContext, type ReactNode, useEffect } from "react";
import type { SiteSettingsUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { initLinkTracking } from "#/_packages/umbrella/utils/link-tracking";

export const SiteSettingsContext = createContext<
	SiteSettingsUmbPageContentResponseModel | undefined
>(undefined);

export function SiteSettingsProvider({
	settings,
	children,
}: {
	settings: SiteSettingsUmbPageContentResponseModel;
	children: ReactNode;
}) {
	useEffect(() => initLinkTracking(document), []);
	return <SiteSettingsContext value={settings}>{children}</SiteSettingsContext>;
}
